import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { VisitDiagnoses } from '~libs.shared.visit';

import { MedicineReplacementModal } from './MedicineReplacementModal';
import { MedicineReplacementSource } from './medicineReplacement.types';

type MedicineReplacementModalOpenActionRenderProps = {
   openModal: VoidFunction;
};

type MedicineReplacementModalOpenActionProps = {
   readonly children: (props: MedicineReplacementModalOpenActionRenderProps) => JSX.Element;
   readonly withdrawnMedicine: MedicineSimple;
   readonly patientId: Patient['id'];
   readonly medicineId: number;
   readonly visitDiagnoses: VisitDiagnoses;
   readonly source: MedicineReplacementSource;
};

export const MedicineReplacementModalOpenAction = (props: MedicineReplacementModalOpenActionProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <MedicineReplacementModal
               onClose={closeModal}
               withdrawnMedicine={props.withdrawnMedicine}
               patientId={props.patientId}
               medicineId={props.medicineId}
               visitDiagnoses={props.visitDiagnoses}
               source={props.source}
            />
         ) : null}
      </>
   );
};
